module.exports = __webpack_public_path__ + "static/media/background.025307d6.jpg";